import { useQuery } from "@tanstack/react-query";
import api from "../services/api";
import logger from "../utils/logger";

export const useDeal = (dealId, options = {}) => {
  const {
    enabled = true,
    onSuccess,
    onError,
    staleTime = 5 * 60 * 1000, // 5 minutes default
    ...queryOptions
  } = options;

  const query = useQuery({
    queryKey: ["deal", dealId],
    queryFn: async () => {
      try {
        const res = await api.get(`/deals/${dealId}`);
        logger.log(`✅ Deal fetched: ${dealId}`, res.data);
        return res.data;
      } catch (error) {
        logger.error(`❌ Failed to fetch deal ${dealId}:`, error.response?.data || error.message);
        throw error;
      }
    },
    enabled: enabled && !!dealId,
    staleTime,
    onSuccess,
    onError,
    ...queryOptions, // Allow caller to override any other options
  });

  return {
    deal: query.data || null,
    loading: query.isLoading,
    error: query.error?.response?.data?.message || query.error?.message || null,
    refetch: query.refetch,
  };
};
